<script setup>
import {ref, reactive, onMounted, watch, computed, nextTick } from 'vue'
// import { useStageStore } from '../../stores/form';
import { useStageStore } from '../../stores/stage';
import { useRoute } from 'vue-router'
import { useConfigStore } from '../../stores/config';

const formStore = useStageStore()
const route = useRoute()
const configStore = useConfigStore()

const showPath = ref(false)
const props = defineProps(['connector','update'])
const defaultStrokeColor = ref('#000')
const start = reactive({
  x: null,
  y: null
})
const end = reactive({
  x: null,
  y: null
})
const source = ref(null)
const target = ref(null)

onMounted(() => {
  if (props.connector) {
    source.value = formStore.getStageById(props.connector.source)[0]
    target.value = formStore.getStageById(props.connector.target)[0]

    if (source.value   && source.value.node.location) {
      start.x = source.value.node.location.cx
      start.y = source.value.node.location.cy
    }

    if (target.value && target.value.node.location) {
      end.x = target.value.node.location.cx
      end.y = target.value.node.location.cy
    }

    if (start.x !== null && end.x !== null) {
      showPath.value = true
    }
  }
})

const getStrokeColor = computed(() => {
  let color = defaultStrokeColor.value
  return color
})


watch(() => props.connector, () => {
  if (props.connector) {
    source.value = formStore.getStageById(props.connector.source)[0]
    target.value = formStore.getStageById(props.connector.target)[0]

    if (source.value   && source.value.node.location) {
      start.x = source.value.node.location.cx
      start.y = source.value.node.location.cy
    }

    if (target.value && target.value.node.location) {
      end.x = target.value.node.location.cx
      end.y = target.value.node.location.cy
    }
    showPath.value = true

  }
})


watch(() => props.connector, () => {
  if (props.connector) {
    source.value = formStore.getStageById(props.connector.source)[0]
    target.value = formStore.getStageById(props.connector.target)[0]

    if (source.value   && source.value.node.location) {
      start.x = source.value.node.location.cx
      start.y = source.value.node.location.cy
    }

    if (target.value && target.value.node.location) {
      end.x = target.value.node.location.cx
      end.y = target.value.node.location.cy
    }
    showPath.value = true


  }
})

watch(() => props.update, () => {
  if (props.update !== null) {

    if (source.value.id === props.update.id) {
      start.x = props.update.x
      start.y = props.update.y
    }
    if (target.value.id === props.update.id) {
      end.x = props.update.x
      end.y = props.update.y
    }

  }

})
const getArrowHeadType = computed(() => 'arrowhead')
</script>

<template>
  <g v-if="showPath">
    <path :d="`M${start.x},${start.y},${end.x} ${end.y}`" stroke-width="2" :stroke="getStrokeColor" :marker-end="`url(#${getArrowHeadType})`" />
    <path :d="`M${start.x},${start.y},${end.x} ${end.y}`" stroke-width="10" stroke="transparent" />
  </g>
</template>